import { SxProps, Theme } from '@mui/material';

const styles = {
  inputMaxWidth: {
    '& .MuiInputBase-root': {
      maxWidth: '51px',
    },
  },
  recurrenceContainer: {
    // minWidth: 369,
    '& fieldset': { border: 'none' },
  },
  timeContainer: {
    display: 'flex',
    gap: '30px',
    marginBottom: '16px',
  },

  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
  checkbox: {
    marginBottom: '1.2rem',
  },

  checkboxLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'grey.800',
  },

  field: {
    flex: 2,
  },

  select: {
    mt: '3px',
    flex: 1,
  },

  selectButton: {
    borderRadius: '9px',
  },

  counterOfferBtn: {
    backgroundColor: 'common.lightGreen',
    border: 'none',
  },

} satisfies Record<string, SxProps<Theme>>;

export default styles;
